import { gql } from '@apollo/client';

import { ENTITY_LIST_FRAGMENT } from './queries';

export const UPLOAD_ENTITY_METADATA_MUTATION = gql`
  mutation UploadEntityMutationsCsv($file: Upload!) {
    uploadEntityMutationsCsv(file: $file) {
      uploadedEntitiesCount
    }
  }
`;

export const UPDATE_ENTITY_SUPPRESSION_MUTATION = gql`
  mutation UpdateEntitySuppression($entityId: ID!, $suppressed: Boolean!) {
    updateEntityWhitelist(entityId: $entityId, whitelistFlag: $suppressed) {
      data {
        ...EntityListFragment
      }
    }
  }
  ${ENTITY_LIST_FRAGMENT}
`;
